import Highcharts from "highcharts";
import HighchartsMoreFn from "highcharts/highcharts-more";
import HighchartsAccessibilityFn from "highcharts/modules/accessibility";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
HighchartsMoreFn(Highcharts);
HighchartsAccessibilityFn(Highcharts);
HighchartsNoData(Highcharts);

export function calculatorChart(simulation_data, period) {
  let viewContent = $(
    ".simulation_content:not(.hidden) .simulation_box:not(.hidden)"
  );
  $(".simulation_content:first-child:not(.hidden) .simulation_box:not(.hidden)")
    .find("#content_text_1")
    .attr("data-target-amount", "");
  let yAxis = simulation_data;
  let seriesData1 = {};
  let seriesData2 = {};
  seriesData1.data = [];
  seriesData2.data = [];
  // 追加初始数据
  let initialAmount = getNumber(
    viewContent
      .find("#initial_amount_input, #assets_amount_input")
      .attr("data-value"),
    10000
  );
  let idx1 = $(".pageCon_simulation .simulation_content").index(
    $(".simulation_content:not(.hidden)")
  );
  let idx2 = $(".pageCon_simulation .simulation_content:not(.hidden)")
    .find(".simulation_box")
    .index(
      $(
        ".pageCon_simulation .simulation_content:not(.hidden) .simulation_box:not(.hidden)"
      )
    );
  if (idx1 == 1 && idx2 == 3)
    initialAmount = getNumber(
      viewContent.find("#content_text_1").text(),
      10000
    );
  let yAxisMin = initialAmount;
  if (initialAmount >= 0 && simulation_data.length >= 12) {
    seriesData1.data = [
      {
        y: initialAmount,
        name: "0年",
        events: {
          mouseOver: function () {
            return false;
          },
          select: function () {
            return false;
          },
        },
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
    ];
    seriesData2.data = [
      {
        y: initialAmount,
        name: "0年",
        events: {
          mouseOver: function () {
            return false;
          },
          select: function () {
            return false;
          },
        },
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
    ];
    viewContent.find(".chart_unit").removeClass("hidden");
  } else {
    viewContent.find(".chart_unit").addClass("hidden");
  }
  for (let j = 0; j < yAxis.length; j++) {
    let ySeries1 = {};
    let ySeries2 = {};
    if ((j + 1) % 12 == 0 && period != 0) {
      ySeries1.y = yAxis[j][yAxis[j].length - 1] + yAxis[j][1];
      ySeries2.y = yAxis[j][1];
      ySeries1.name = yAxis[j][0] / 12 + "年";
      ySeries2.name = yAxis[j][0] / 12 + "年";
      seriesData1.data.push(ySeries1);
      seriesData2.data.push(ySeries2);
      yAxisMin =
        yAxisMin < (ySeries2.y < ySeries1.y ? ySeries2.y : ySeries1.y)
          ? yAxisMin
          : ySeries2.y < ySeries1.y
          ? ySeries2.y
          : ySeries1.y;
      $(
        ".simulation_content:first-child:not(.hidden) .simulation_box:not(.hidden)"
      )
        .find("#content_text_1")
        .attr("data-target-amount", ySeries1.y);
    }
  }
  let seriesDatas = [seriesData1, seriesData2];
  let areasOption = areasplineOption;
  let divId = $(
    ".simulation_content:not(.hidden) .simulation_box:not(.hidden) .calculator_chart"
  ).attr("id");
  let options = [
    { name: ["合計", "投資総額"] },
    { fillColor: ["rgba(239, 246, 255, 0.5)", "rgba(203, 213, 225, 0.4)"] },
    { fillOpacity: [0.5, 0.4] },
    { lineColor: ["#3B82F6", "#94A3B8"] },
    { color: ["#3B82F6", "#94A3B8"] },
    { zIndex: [1, 2] },
  ];
  let colors = ["#3B82F6", "#94A3B8"];
  if (idx1 == 1) {
    seriesDatas = [seriesData2, seriesData1];
    options = [
      { name: ["当初金融資産の残高", "金融資産額（合計）"] },
      { fillColor: ["rgba(203, 213, 225, 0.4)", "rgba(239, 246, 255, 0.5)"] },
      { fillOpacity: [0.4, 0.5] },
      { lineColor: ["#94A3B8", "#3B82F6"] },
      { color: ["#94A3B8", "#3B82F6"] },
      { zIndex: [2, 1] },
    ];
    colors = ["#94A3B8", "#3B82F6"];
  }
  seriesDatas.forEach(function (val, idx) {
    areasplineOption["series"][idx]["data"] = seriesDatas[idx].data;
    areasplineOption["series"][idx]["marker"]["states"]["hover"]["fillColor"] =
      colors[idx];
    options.forEach(function (value) {
      areasplineOption["series"][idx][Object.keys(value)] =
        value[Object.keys(value)][idx];
    });
  });
  areasplineOption["chart"]["height"] =
    $("main").find(".simulation_sp").length > 0 ? 223 : 389;
  areasplineOption["tooltip"].formatter = function () {
    let tooltipColors = ["#3B82F6", "#475569"];
    let tooltip =
      `<div class='py-2.25 px-3 text-itf-xs shadow-[0_0.0625rem_0.1875rem_rgba(0,0,0,0.1),0_0.0625rem_0.125rem_-0.0625rem_rgba(0,0,0,0.1)] bg-white rounded-md'>
        <div class='mb-1.25 text-center'>` +
      this.points[0].key +
      `後
    </div>`;
    let num = 0;
    if (this.points[0].key == "0年") {
      return false;
    } else {
      let benefit =
        idx1 == 0
          ? this.points[0].y - this.points[1].y
          : this.points[1].y - this.points[0].y;

      for (let i = this.points.length - 1; i >= 0; i--) {
        num += this.points[i].y;
        if (this.points[i].series.name != " ") {
          tooltip +=
            "<div class='tooltip_flex' style='color:" +
            tooltipColors[1] +
            "'><span>" +
            this.points[i].series.name +
            "</span>" +
            Highcharts.numberFormat(
              Math.round(this.points[i].y / 10000),
              0,
              ",",
              ","
            ) +
            "万円</div>";
          if (i == this.points.length - 1) {
            tooltip +=
              '<div class="tooltip_flex" style="color:' +
              tooltipColors[0] +
              '"><span>運用利益</span>' +
              Highcharts.numberFormat(
                Math.round(benefit / 10000),
                0,
                ",",
                ","
              ) +
              "万円</div>";
          }
        }
      }

      tooltip += "</div>";
      return tooltip;
    }
  };
  areasplineOption["yAxis"]["min"] = yAxisMin > 0 ? 0 : yAxisMin;
  let areasObj = Highcharts.chart(divId, areasOption, function (chart) {
    if (chart) {
      let series = chart.series[0].data;
      let seriesLength = Number(series.length);
      let cabLength = Math.floor(seriesLength / 10) * 10;
      let cabArr = [
        {
          0: 2,
          10: 3,
          20: 5,
          30: 6,
          40: 8,
          50: 10,
          60: 12,
          70: 14,
          80: 16,
          90: 18,
          100: 20,
        },
        {
          0: 2,
          10: 2,
          20: 3,
          30: 5,
          40: 6,
          50: 8,
          60: 10,
          70: 12,
          80: 14,
          90: 16,
          100: 18,
        },
      ];
      let cab = 2;

      if ($("main").find(".simulation_sp").length > 0) {
        cab = seriesLength <= 5 ? 1 : cabArr[0][cabLength];
      } else {
        cab = seriesLength <= 9 ? 1 : cabArr[1][cabLength];
      }
      chart.series[0].data.forEach(function (item, idx) {
        if (idx % cab == 0 && item.name != "0年") {
          let textX =
            item.plotX + chart.plotLeft - (String(idx).length * 8 + 12) / 2;
          chart.renderer
            .text(item.name, textX, chart.chartHeight - 1)
            .css({
              color: "#64748B",
              fontSize: "12.25px",
              fontWeight: "bold",
            })
            .add();
        }
      });
    }
  });
}

let areasplineOption = {
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: "transparent",
    height: 389,
    animation: false,
    marginTop: 8,
    marginBottom: 17,
    plotBorderWidth: 2,
    plotBorderColor: "transparent",
    style: {
      fontFamily:
        "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
    },
    plotBackgroundImage:
      $("main").find(".simulation_sp").length > 0
        ? "/images/simulation_line_sp.svg"
        : "/images/simulation_line_pc.svg",
  },
  title: {
    text: "",
  },
  legend: {
    enabled: false,
  },
  series: [
    {
      type: "areaspline",
      name: "",
      fillColor: "",
      fillOpacity: "",
      lineColor: "",
      data: "",
      marker: {
        states: {
          hover: {
            fillColor: "",
            lineWidth: 0,
            lineWidthPlus: 0,
            radius: 5,
            radiusPlus: 0,
          },
          select: {
            fillColor: "",
            lineWidth: 0,
            lineWidthPlus: 0,
            radius: 5,
            radiusPlus: 0,
          },
        },
        symbol: "circle",
        radiusPlus: 0,
      },
    },
    {
      type: "areaspline",
      name: "",
      fillColor: "",
      fillOpacity: "",
      lineColor: "",
      data: "",
      marker: {
        states: {
          hover: {
            fillColor: "",
            lineWidth: 0,
            lineWidthPlus: 0,
            radius: 5,
            radiusPlus: 0,
          },
          select: {
            fillColor: "",
            linWidth: 0,
            lineWidthPlus: 0,
            radius: 5,
            radiusPlus: 0,
          },
        },
        symbol: "circle",
        radiusPlus: 0,
      },
    },
  ],
  lang: {
    noData: ''
  },
  tooltip: {
    enabled: true,
    shared: true,
    backgroundColor: "transparent",
    borderColor: "transparent",
    shadow: false,
    useHTML: true,
    formatter: function () {},
  },
  xAxis: {
    title: {
      text: "",
    },
    lineWidth: 0,
    tickWidth: 0,
    gridLineWidth: 0,
    category: "",
    startOnTick: true,
    type: "datetime",
    labels: {
      enabled: false,
    },
  },
  yAxis: {
    title: {
      text: "",
    },
    lineWidth: 0,
    tickWidth: 0,
    gridLineWidth: 0,
    startOnTick: false,
    min: 0,
    labels: {
      style: {
        color: "#64748B",
        fontSize: "12.25px",
        fontWeight: "bold",
      },
      formatter: function () {
        let yAxisLabel = Highcharts.numberFormat(
          this.value / 10000,
          0,
          ",",
          ","
        );
        return yAxisLabel;
      },
    },
  },
  plotOptions: {
    series: {
      clip: false,
      lineWidth: 2,
      marker: {
        enabled: false,
      },
      states: {
        inactive: {
          opacity: 1,
        },
        hover: {
          lineWidth: 2,
        },
      },
    },
  },
};

// 参数判断
export function getNumber(target, coefficient) {
  if (target == undefined) {
    return 0;
  } else {
    target = target.replace(/,/gi, "");
    return Number(target) * coefficient;
  }
}
